import { GET_TELE_LINKS_V2 } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default async (aid: string) => {
    try {
        const response = await fetchWithRefresh(GET_TELE_LINKS_V2(aid));
        const data = await response.json();
        return {
            host_url: data.host_url,
            guest_url: data.guest_url,
        };
    } catch (err) {
        console.error('Failed to get tele room links', err);
        return undefined; // do we need a fail safe like callig 100ms again or somethiing of that sort?
    }
};
